import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=608b2cd2&scoped=true"
import script from "./Cities.vue?vue&type=script&lang=js"
export * from "./Cities.vue?vue&type=script&lang=js"
import style0 from "./Cities.vue?vue&type=style&index=0&id=608b2cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608b2cd2",
  null
  
)

export default component.exports